;(function () {
  'use strict'

  angular
    .module('deskfy.core')
    .directive('multiselect', multiselect)

  function multiselect () {
    return {
      restrict: 'A',
      scope: {
        onSelectedItem: '&',
        onChange: '&'
      },
      controller: MultiselectController
    }
  }

  /* @ngInject */
  function MultiselectController ($scope, $element) {
    var vm = this
    vm.items = []

    function init () {
      vm.items = $element.children()
      vm.items.each(function (i, item) {
        angular.element(item).addClass('multiselect-item')
      })

      $element.children('.multiselect-item').on('click', function (event) {
        var item = angular.element(event.currentTarget)
        item.toggleClass('selected')

        var selected = item.hasClass('selected')
        if (selected) {
          $scope.onSelectedItem({ item: item })
        }

        $scope.onChange({ item: item, selected: selected })
      })
    }

    $scope.$parent.$on('LastRepeaterItem', init)
  }
})()
